import { useMutation } from '@apollo/client'
import { gql } from '~/__generated__'
import { isUnauthenticated } from './apollo'
import { useLogin } from './useLogin'

const LOGOUT = gql(`
  mutation Logout {
    logout
  }
`)

export const useLogout = () => {
  const { navigateToLogin } = useLogin()

  return useMutation(LOGOUT, {
    onCompleted: () => navigateToLogin(),
    onError: (err) => {
      if (isUnauthenticated(err.graphQLErrors)) {
        navigateToLogin()
      }
    },
  })
}
